
// ****************************** Import From AWS Amplify ******************************** //

import { Amplify } from 'aws-amplify';

import outputs from "/amplify_outputs.json";

Amplify.configure(outputs);

// ****************************** Import CSS ******************************** //

import "./index.css";

// ****************************** Import Images ******************************** //

// ****** I IS WE NEW LOGO ****** //

import "./assets/logos/iiswe-logo.png"

// ****** HERO IMAGE ****** //

import "./assets/hero-images/chess-hero-image.png"
import "./assets/hero-images/chess-hero-image-2.png"

import "./assets/hero-images/iiswe-learning-chess.jpg"
import "./assets/hero-images/learning-chess-sm.jpg"

// ****** OTHER IMAGES ****** //

import "./assets/chess-photos/playing-chess-park-1.jpg"
import "./assets/chess-photos/playing-chess-park-2.jpg"

// ****** YOUTH TESTIMONIAL VIDEOS ****** //

import "./assets/youth-testimonials/youth-testimonial-1.mp4"
import "./assets/youth-testimonials/youth-testimonial-2.mp4"


import "./assets/workshop-photos/lunch-n-learn-workshop-10.jpg"

import "./assets/caring-community-photos/old-savannah-mission.jpg"

// ****** SPONSOR LOGOS ****** //

import "./assets/sponsor-logos/mcdonalds-logo.png"
import "./assets/sponsor-logos/taco-bell-logo.png"
import "./assets/sponsor-logos/forsyth-farmers-market-logo.png"
import "./assets/sponsor-logos/little-caesars-logo.png"
import "./assets/sponsor-logos/mellow_mushroom_logo.svg"
import "./assets/sponsor-logos/urban-deli-logo.png"

// **************************** Add Top Nav & Footer ************************** //

import './nav-header-footer/nav-header-footer.js';
import './nav-header-footer/nav-header-footer.css';

// ******************** Add Homepage Announcement Banner ******************** //

// import './homepage-banners/2-chess-tourn-2025/p2k2025.js';

// ******************** Add Homepage Announcement Banner ******************** //

import './homepage-banners/3-we-outside/we-outside-popup-banner.js';

// **************************** Flyer Popup Modal ************************** //

import '/src/popups/flyer-popup.js';
import '/src/popups/flyer-popup.css';

// ************ Add Email Signup *************** //

